var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5416 28C43.5403 28.4232 43.4219 28.8378 43.1994 29.1978C42.977 29.5578 42.6591 29.8492 42.2812 30.0396L19.3645 41.4979C19.0453 41.6615 18.692 41.7479 18.3333 41.75C17.9042 41.7514 17.4834 41.6323 17.1187 41.4063C16.7885 41.1999 16.5162 40.9127 16.3278 40.5719C16.1393 40.231 16.0409 39.8478 16.0416 39.4584V16.5417C16.0428 16.151 16.1438 15.7672 16.3351 15.4266C16.5264 15.0859 16.8015 14.7999 17.1345 14.5955C17.4674 14.3912 17.8471 14.2753 18.2374 14.259C18.6277 14.2426 19.0157 14.3263 19.3645 14.5021L42.2812 25.9604C42.6591 26.1509 42.977 26.4422 43.1994 26.8022C43.4219 27.1623 43.5403 27.5768 43.5416 28Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/playIcon.365f151bb014a67ecb4695648222b7f3.svg";
export { ForwardRef as ReactComponent };